export default "__VITE_ASSET__CoAY5ICl__"